<div class="container-fluid">
    <div class="row marT32">
        <div class="col-md-12 col-12" *ngIf="candidateBasicDetails">
            <candidate-profile [isSearch]="isSearch" [profileData]="candidateBasicDetails" [candAppIds]="candAppIds"
            [appId]="appId" [isRecruiter]="recruiter" [candidateId]="selectedCandidateId"  [interviewList]="interviewDetails" (openResume)="openFile($event)" (selectedAppId) = "getAppId($event)"> 
            </candidate-profile>
            <mat-tab-group class="marT32" #unittabGroup [selectedIndex]="selectedAssignmentTab.value"
                (selectedIndexChange)="selectedAssignmentTab.setValue($event)" animationDuration="0ms"
                style="background: #fff; " (selectedTabChange)="onAssignmentChange($event)" name="assignmentTabGroup">
                <mat-tab label='Assignment {{ i + 1 }}' *ngFor="let application of applicationIds; let i = index"
                    class="applicationtab" name="reqUnitTab">
                    <div id="Container" class="container-fluid pt-0 pb-0 mt-0 mb-0">
                        <div id="detailrow" class="row">
                            <div class="row">
                                <div class="d-flex flex-wrap align-items-center padT24">
                                    @for (detail of interviewDetails; track detail.iwpInterviewId; let ind = $index) {
                                        @if (!hideIWPSharing() && showInterviewActionButtons && detail.interviewName?.includes('[Technical]')) {
                                        <span class="secondary-btn mr-2 mb-2 interviewBtn interview-pill-technical" [class.interview-selected]="selectedInterviewIds.has(detail.iwpInterviewId)">
                                            <input type="checkbox" class="interview-checkbox" style="margin-right: 6px;"
                                                   [checked]="selectedInterviewIds.has(detail.iwpInterviewId)"
                                                   (change)="toggleInterviewSelection(detail.iwpInterviewId)">
                                            <span class="interview-pill-label" (click)="openInterviewDetails(selectedCandidateId, detail.iwpInterviewId)">{{detail.interviewName}} {{detail.startDate | date:'dd MMM yy'}} {{detail.startTime}}</span>
                                        </span>
                                        } @else {
                                        <button mat-flat-button name="interviewBtn" class="secondary-btn mr-2 mb-2 interviewBtn"
                                                (click)="openInterviewDetails(selectedCandidateId, detail.iwpInterviewId)">
                                            {{detail.interviewName}} {{detail.startDate | date:'dd MMM yy'}} {{detail.startTime}}
                                        </button>
                                        }
                                    }
                                    @if (interviewDetails && roleCode =='Recruiter' && dataSource[0].processName == 'Interview' && [1,2,4].includes(application.companyHiringTypeId)) {
                                    <button class="btn btn-primary ml-2 mb-2 interviewBtn" (click)="synciwp(application)">Sync</button>
                                    }
                                </div>
                                @if (!hideIWPSharing() && showInterviewActionButtons) {
                                <div class="box d-flex align-items-center justify-content-between border rounded p-2 mt-2">
                                    <small class="interview-hint mb-0">
                                        @if (selectedInterviewIds.size > 0) {
                                            {{ selectedInterviewIds.size }} {{ selectedInterviewIds.size === 1 ? 'interview' : 'interviews' }} selected
                                        } @else {
                                            Select interviews above to share
                                        }
                                    </small>
                                    <div class="d-flex interview-btn-group">
                                        <button mat-stroked-button class="interview-action-btn clear-btn" [disabled]="selectedInterviewIds.size === 0" (click)="clearSelectedInterviews()">Clear</button>
                                        <button mat-stroked-button class="interview-action-btn share-btn" [disabled]="selectedInterviewIds.size === 0" (click)="shareSelectedInterviews()">Share</button>
                                    </div>
                                </div>
                                }
                            <!-- <div class="col-md-4 padT24 padL16 d-flex" *ngFor="let detail of interviewDetails; let ind = index">
                                <button mat-flat-button name="interviewBtn" class="secondary-btn" (click)="openInterviewDetails(selectedCandidateId,detail.iwpInterviewId)">{{detail.interviewName}} {{detail.startDate | date:'dd MMM yy'}} {{detail.startTime}}</button>
                                
                            </div>
                            <div class="col-md-2 padT24">
                                <button class="btn btn-primary ml-2" *ngIf="interviewDetails && dataSource[0].processName == 'Interview'" (click)="synciwp(application)">sync</button>
                            </div> -->
                            
                            @if (showShlAssessment()) {
                            <div class="col-md-4 padT24 padL16">
                                <button mat-flat-button name="shlBtn" class="secondary-btn" (click)="openShlDetails()">SHL Assessment</button>
                            </div>
                            }
                            </div>
                            <div id="detailCol" class="col-12">
                                <!-- <h3 *ngIf="applicationData.length > 0" class="h3Header candidate marB8" name="candidateheading">
                                    <strong>Assignments</strong>
                                </h3> -->
                                <div id="detail_op" class="search-container marT24 marB16">
                                    <table aria-describedby="display search table detail" id="table_op" mat-table [dataSource]="dataSource" multiTemplateDataRows aria-describedby="mydesc">
                    
                                        
                                        <ng-container matColumnDef="requisitionName" id="tablerequisitionName">
                                            <th id="NameTH" mat-header-cell *matHeaderCellDef id="requisition" class="GreylighterBg text-center">Requisition </th>
                                            <td id="NameTD{{element.requisitionName}}" mat-cell style="cursor: pointer" class="active-txt" 
                                            [ngClass]="{'active-btn': selectedRequisitionId === element.requisitionName}" *matCellDef="let element"  
                                            (click)="selectRequisition(element)"> {{element.requisitionName}} </td>
                                        </ng-container>

                    <ng-container id="HiringTypeName" matColumnDef="companyHiringTypeName">
                      <th mat-header-cell *matHeaderCellDef id="companyHiringType" class="GreylighterBg text-center">
                        Company Hiring Type
                      </th>
                      <td id="NameTD{{ element.companyHiringTypeName }}" mat-cell *matCellDef="let element">
                        {{ element.companyHiringTypeName }}
                      </td>
                    </ng-container>

                    <ng-container id="Date_op" matColumnDef="applicationDate">
                      <th mat-header-cell *matHeaderCellDef id="createdOn" class="GreylighterBg text-center">
                        Created On
                      </th>
                      <td id="DateTD{{ element.companyHiringTypeName }}" mat-cell *matCellDef="let element">
                        {{ element.applicationDate | date: 'MMM d, y' }}
                      </td>
                    </ng-container>

                    <ng-container id="acvtyName" matColumnDef="activityName">
                      <th mat-header-cell *matHeaderCellDef id="lastActivity" class="GreylighterBg text-center">
                        Last Activity
                      </th>
                      <td id="sNameTD{{ element.activityName }}" mat-cell *matCellDef="let element">
                        {{ element.activityName }}
                      </td>
                    </ng-container>

                    <ng-container id="processN" matColumnDef="processName">
                      <th mat-header-cell *matHeaderCellDef id="process" class="GreylighterBg text-center">Process</th>
                      <td id="NpNameTD{{ element.processName }}" mat-cell *matCellDef="let element">
                        {{ element.processName }}
                      </td>
                    </ng-container>

                    <ng-container id="Status_op" matColumnDef="applicationStatus">
                      <th mat-header-cell *matHeaderCellDef id="status" class="GreylighterBg text-center">Status</th>
                      <td id="Stas{{ element.applicationStatus }}" mat-cell *matCellDef="let element">
                        {{ element.applicationStatus }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="subStatus" id="subStatus_op">
                      <th mat-header-cell *matHeaderCellDef id="status" class="GreylighterBg text-center">
                        Sub Status
                      </th>
                      <td id="sub{{ element.subStatus }}" mat-cell *matCellDef="let element">
                        {{ element.subStatus }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="sourceName" id="CsN_op">
                      <th mat-header-cell *matHeaderCellDef id="source" class="GreylighterBg text-center">Source</th>
                      <td id="sCsN{{ element.sourceName }}" mat-cell *matCellDef="let element">
                        {{ element.sourceName }}
                      </td>
                    </ng-container>

                    <ng-container id="ExpiryDate_op" matColumnDef="sourceExpiryDate">
                      <th mat-header-cell *matHeaderCellDef id="expiryDate" class="GreylighterBg text-center">
                        Source Expiry Date
                      </th>
                      <td id="ExyDt{{ element.sourceName }}" mat-cell *matCellDef="let element">
                        {{ element.sourceExpiryDate | date: 'MMM d, y' }}
                      </td>
                    </ng-container>
                    <ng-container id="emplyeNum" matColumnDef="employeeNumber">
                      <th mat-header-cell *matHeaderCellDef id="empNumber" class="GreylighterBg text-center">
                        Employee Number
                      </th>
                      <td id="NumTD{{ element.sourceName }}" mat-cell *matCellDef="let element">
                        {{ element.employeeNumber }}
                      </td>
                    </ng-container>
                    <ng-container id="EmployeeId_op" matColumnDef="candiadteEmployeeId">
                      <th mat-header-cell *matHeaderCellDef id="candidateEmpId" class="GreylighterBg text-center">
                        Candidate Employee No
                      </th>
                      <td id="Eee{{ element.sourceName }}" mat-cell *matCellDef="let element">
                        {{ element.candiadteEmployeeId }}
                      </td>
                    </ng-container>
                    <ng-container id="applicationId" matColumnDef="applicationId">
                      <th mat-header-cell *matHeaderCellDef id="applicationId" class="GreylighterBg text-center">
                        Application Id
                      </th>
                      <td id="Eee{{ element.sourceName }}" mat-cell *matCellDef="let element">
                        {{ element.applicationId }}
                      </td>
                    </ng-container>
                    <ng-container id="isReOffered" matColumnDef="isReOffered">
                      <th mat-header-cell *matHeaderCellDef id="isReOffered" class="GreylighterBg text-center">
                        Re-Offer
                      </th>
                      <td id="Eee{{ element.isReOffered }}" mat-cell *matCellDef="let element">
                        <span *ngIf="element.isReOffered && element.isReOffered.toLowerCase() === 'y'">Yes</span>
                        <span
                          *ngIf="
                            !element.isReOffered || (element.isReOffered && element.isReOffered.toLowerCase() === 'n')
                          "
                          >No</span
                        >
                      </td>
                    </ng-container>
                    <tr id="searContnerTR_op" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr id="searContTR_op" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12" *ngIf="application.applicationId == appId">
                <div *ngFor="let item of groupedActivities | keyvalue; let j = index" class="row">
                  <div class="text-center col-md-12 container-process">
                    <div class="line-process">
                      <mat-divider
                        style="width: 100%; display: inline-block; box-shadow: 0px 1px #00000029"
                      ></mat-divider>
                    </div>
                    <span class="process GreyLight" name="dateheader">{{ item.value[0].processName }}</span>
                    <div class="line-process">
                      <mat-divider
                        style="width: 100%; display: inline-block; box-shadow: 0px 1px #00000029"
                      ></mat-divider>
                    </div>
                  </div>
                  <div *ngFor="let actvity of item.value; let indx1 = index" class="col-12">
                    <div *ngIf="indx1 != item.value.length - 1 && item.value.length != 1" class="customActivityCard">
                      <span>
                        <h3 name="activityDescSearch1" class="act-desc inline activitydescription marL4">
                          {{ actvity.activityDescription }}
                        </h3>
                        <p class="mainBodyTxt2 inline GreyLight marL8">
                          {{ actvity.modifiedOn | date: 'd LLL yyyy' }}
                        </p>
                        <span
                          style="float: right"
                          [ngClass]="{ mtminus: actvity.editflag === 'true' || actvity.readflag === 'true' }"
                        >
                          <!-- <span class="activity-data-letters float-left marR16">{{activity.modifiedBy| initials}}</span> -->
                          <p
                            class="mainBodyTxt2 inline GreyLight marL4"
                            [ngClass]="{ pos: actvity.editflag === 'true' || actvity.readflag === 'true' }"
                          >
                            {{ actvity.modifiedByName }}
                          </p>

                          <!-- <button class="Icon-Btn mat-icon-button mat-button-base" name="deletebtn{{i}}" mat-icon-button="" *ngIf="activity.editflag" (click)="deleteActivityCard(activity)">
                                                <span class="mat-button-wrapper">
            
                                                    <img alt="icon-delete-mini" id="deleteImg{{i}}" src="assets/images/icons/purple_icons/icon-delete-mini.png">
                                                </span>
                                                <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple="">
                                                </div>
                                                <div class="mat-button-focus-overlay">
                                                </div>
                                            </button> -->
                          <button
                            class="mat-icon-button mat-button-base"
                            [hidden]="processStageDisable"
                            mat-icon-button=""
                            name="editbtn{{ indx1 }}"
                            *ngIf="actvity.editflag === 'true'"
                            (click)="editActivity(actvity, 'edit')"
                          >
                            <span class="mat-button-wrapper">
                              <img
                                alt="icon-edit"
                                id="editImg{{ indx1 }}"
                                src="assets/images/icons/purple_icons/icon-edit.png"
                              />
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""></div>
                            <div class="mat-button-focus-overlay"></div>
                          </button>

                          <button
                            class="mat-icon-button mat-button-base"
                            [hidden]="processStageDisable"
                            mat-icon-button=""
                            name="readbtn{{ indx1 }}"
                            *ngIf="actvity.readflag === 'true' && actvity.editflag === 'false'"
                            (click)="editActivity(actvity, 'read')"
                          >
                            <span class="mat-button-wrapper">
                              <img
                                alt="icon-read"
                                id="readImg{{ indx1 }}"
                                src="assets/images/icons/purple_icons/icon-show.png"
                              />
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""></div>
                            <div class="mat-button-focus-overlay"></div>
                          </button>
                          <!-- <p class="mainBodyTxt2 inline GreyLight marL8" (click)="editActivity(activity)">edit</p> -->
                          <!-- <p class="mainBodyTxt2 inline GreyLight marL8" *ngIf="activity.editflag" (click)="editActivity(activity)">edit</p> -->
                        </span>
                      </span>
                    </div>
                    <div *ngIf="indx1 == item.value.length - 1 || item.value.length == 1" class="customActivityCard1">
                      <span>
                        <h3 name="activityDescSearch2" class="act-desc inline activitydescription marL4">
                          {{ actvity.activityDescription }}
                        </h3>
                        <p class="mainBodyTxt2 inline GreyLight marL8">
                          {{ actvity.modifiedOn | date: 'd LLL yyyy' }}
                        </p>
                        <span
                          style="float: right"
                          [ngClass]="{ mtminus: actvity.editflag === 'true' || actvity.readflag === 'true' }"
                        >
                          <p
                            class="mainBodyTxt2 inline GreyLight marL4"
                            [ngClass]="{ pos: actvity.editflag === 'true' || actvity.readflag === 'true' }"
                          >
                            {{ actvity.modifiedByName }}
                          </p>

                          <button
                            class="mat-icon-button mat-button-base"
                            [hidden]="processStageDisable"
                            mat-icon-button=""
                            name="editbtn{{ indx1 }}"
                            *ngIf="actvity.editflag === 'true'"
                            (click)="editActivity(actvity, 'edit')"
                          >
                            <span class="mat-button-wrapper">
                              <img
                                alt="icon-edit"
                                id="editImg{{ indx1 }}"
                                src="assets/images/icons/purple_icons/icon-edit.png"
                              />
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""></div>
                            <div class="mat-button-focus-overlay"></div>
                          </button>

                          <button
                            class="mat-icon-button mat-button-base"
                            [hidden]="processStageDisable"
                            mat-icon-button=""
                            name="readbtn{{ indx1 }}"
                            *ngIf="actvity.readflag === 'true' && actvity.editflag === 'false'"
                            (click)="editActivity(actvity, 'read')"
                          >
                            <span class="mat-button-wrapper">
                              <img
                                alt="icon-read"
                                id="readImg{{ indx1 }}"
                                src="assets/images/icons/purple_icons/icon-show.png"
                              />
                            </span>
                            <div class="mat-button-ripple mat-ripple mat-button-ripple-round" matripple=""></div>
                            <div class="mat-button-focus-overlay"></div>
                          </button>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div>
                  <app-activity-dialog
                    *ngIf="editactivityflag"
                    [editcandidateApplicationIds]="candidateApplicationIds"
                    [ifCoupled]="ifCoupled"
                    [interviewFlag]="interviewFlag"
                    [selectedCandidate]="selectedCandidate"
                    [editcheckSuitabilityDataObj]="editcheckSuitabilityDataObj"
                    [editcheckCorrespondenceDataObj]="editcheckCorrespondenceDataObj"
                    [editcheckInterviewDataObj]="editcheckInterviewDataObj"
                    [editcheckStatusChangeDataObj]="editcheckStatusChangeDataObj"
                    [editcheckHrPanelInterviewObj]="editcheckHrPanelInterviewObj"
                    [coupledEditCheckSuitabilityDataObj1]="coupledEditCheckSuitabilityDataObj1"
                    [coupledEditCheckSuitabilityDataObj2]="coupledEditCheckSuitabilityDataObj2"
                    [onSuitability]="onSuitabilityEdit"
                    [onCoupledSuitability]="coupledOnSuitabilityEdit"
                    [coupledEditCheckCorrespondenceDataObj1]="coupledEditCheckCorrespondenceDataObj1"
                    [coupledEditCheckCorrespondenceDataObj2]="coupledEditCheckCorrespondenceDataObj2"
                    [onCorrespondence]="onCorrespondenceEdit"
                    [onCoupledCorrespondence]="coupledOnCorrespondenceEdit"
                    [coupledEditCheckInterviewDataObj1]="coupledEditCheckInterviewDataObj1"
                    [coupledEditCheckInterviewDataObj2]="coupledEditCheckInterviewDataObj2"
                    [onInterviewSchedule]="onInterviewScheduleEdit"
                    [onCoupledInterviewSchedule]="coupledOnInterviewScheduleEdit"
                    [coupledEditCheckStatusChangeDataObj1]="coupledEditCheckStatusChangeDataObj1"
                    [coupledEditCheckStatusChangeDataObj2]="coupledEditCheckStatusChangeDataObj2"
                    [onStatusChangeSchedule]="onStatusChangeScheduleEdit"
                    [onCoupledStatusChangeSchedule]="coupledOnStatusChangeScheduleEdit"
                    [coupledEditCheckHrPanelInterviewObj1]="coupledEditCheckHrPanelInterviewObj1"
                    [coupledEditCheckHrPanelInterviewObj2]="coupledEditCheckHrPanelInterviewObj2"
                    [onHrPanelInterview]="onHrPanelInterviewEdit"
                    [onCoupledHrPanelInterview]="coupledEditHrPanelInterview"
                    [candidateEmails]="candidateEmails"
                    [selectedCandidate]="selectedCandidate"
                    [resetFlag]="resetFlag()"
                    [activityMode]="activityMode"
                  ></app-activity-dialog>
                </div>
                <!-- activity integration-->
                <div *ngIf="selectedCandidate && activityState">
                  <div *ngIf="onSuitability" class="activityCard">
                    <activity-check-suitability
                      [selectedCand]="selectedCandidate"
                      [candidateDetail]="dataSource"
                      [checkSuitabilityDataObj]="checkSuitabilityDataObj"
                      [candidateApplicationIds]="candidateApplicationIds"
                      (refreshcandiates)="callrefreshcandiates($event)"
                    >
                    </activity-check-suitability>
                  </div>
                  <div *ngIf="onCorrespondence" class="activityCard">
                    <activity-correspondence
                      [correspondenceDataObj]="correspondenceDataObj"
                      [candidateEmails]="candidateEmails"
                      [candidateApplicationIds]="candidateApplicationIds"
                      [selectedCandidate]="selectedCandidate"
                      (refreshcandiates)="callrefreshcandiates($event)"
                    ></activity-correspondence>
                  </div>
                  <div *ngIf="onInterviewSchedule" class="activityCard">
                    <activity-scheduleinterview
                      [interviewFlag]="interviewFlag"
                      [checkInterviewSchDataObj]="checkInterviewSchDataObj"
                      [candidateEmails]="candidateEmails"
                      [selectedCandidate]="selectedCandidate"
                      [candidateApplicationIds]="candidateApplicationIds"
                      (refreshcandiates)="callrefreshcandiates($event)"
                    >
                    </activity-scheduleinterview>
                  </div>
                  <div *ngIf="onStatusChangeSchedule" class="activityCard" id="statusChangeActivity">
                    @if (showBackButton()) {
                      <button
                        mat-stroked-button
                        (click)="navigateBack()"
                        class="marB16"
                        style="outline: 0; background-color: #c16df6; color: white"
                      >
                        <mat-icon>arrow_back</mat-icon>
                        Back to Recruiter's Action Pending
                      </button>
                    }
                    <activity-status-change
                      [checkStatusChangeObj]="checkStatusChangeObj"
                      [candidateApplicationIds]="candidateApplicationIds"
                      [candidateObj]="selectedCandidate"
                      [candidateDetail]="dataSource"
                      (refreshcandiates)="callrefreshcandiates($event)"
                      [noOfTimes]="noOfTimesActsExcted"
                      [minDate]="minDateAllowed"
                      [candidateActivities]="activityModel"
                    ></activity-status-change>
                  </div>
                  <div *ngIf="onHrPanelInterview" class="activityCard">
                    <app-activity-hrinterview
                      [checkHrPanelInterviewObj]="checkHrPanelInterviewObj"
                      [candidateApplicationIds]="candidateApplicationIds"
                      (refreshcandiates)="callrefreshcandiates($event)"
                    >
                    </app-activity-hrinterview>
                  </div>

                  <div *ngIf="ifCoupled" class="activityCard">
                    <app-coupled-activity
                      [checkSuitabilityDataObj]="coupledCheckSuitabilityDataObj"
                      [correspondenceDataObj]="couplledCorrespondenceDataObj"
                      [candidateEmails]="candidateEmails"
                      [interviewFlag]="interviewFlag"
                      [checkInterviewSchDataObj]="coupledCheckInterviewSchDataObj"
                      [checkStatusChangeObj]="coupledCheckStatusChangeObj"
                      [onSuitability]="coupledOnSuitability"
                      [onCorrespondence]="coupledOnCorrespondence"
                      [onInterviewSchedule]="coupledOnInterviewSchedule"
                      [onStatusChangeSchedule]="coupledOnStatusChangeSchedule"
                      [coupledcheckSuitabilityDataObj]="coupled2CheckSuitabilityDataObj"
                      [coupledcorrespondenceDataObj]="couplled2CorrespondenceDataObj"
                      [coupledcheckInterviewSchDataObj]="coupled2CheckInterviewSchDataObj"
                      [coupledcheckStatusChangeObj]="coupled2CheckStatusChangeObj"
                      [onCoupledSuitability]="coupled2OnSuitability"
                      [onCoupledCorrespondence]="coupled2OnCorrespondence"
                      [onCoupledInterviewSchedule]="coupled2OnInterviewSchedule"
                      [onCoupledStatusChangeSchedule]="coupled2OnStatusChangeSchedule"
                      [selectedCandidate]="selectedCandidate"
                      [candidateApplicationIds]="candidateApplicationIds"
                      [checkHrPanelInterviewObj]="coupledcheckHrPanelInterviewObj"
                      [onHrPanelInterview]="coupledhrpanelInterview"
                      [coupledcheckHrPanelInterviewObj]="coupled2checkHrPanelInterviewObj"
                      [onCoupledHrPanelInterview]="coupled2hrpanelInterview"
                      [ifCoupled]="ifCoupled"
                      (refreshcandiates)="callrefreshcandiates($event)"
                    >
                    </app-coupled-activity>
                    <!-- <app-coupled-activity [test]="true" [CheckSuitabilityDataObj]="coupledCheckSuitabilityDataObj"
                
                ></app-coupled-activity> -->
                  </div>
                </div>
                <div class="marT16 footer">
                  <span class="messagebox">
                    <ul>
                      <li class="active clearfix">
                        <span class="messagebox-container">
                          <span class="data-letters float-left marR4 message-img-size" name="loginusrname">{{
                            loginUserName | initials
                          }}</span>

                          <div class="messagebox-formfield relative">
                            <input name="messages" placeholder="Write messages down here..." class="messagebox-input" />
                            <a
                              href="javascript:void(0)"
                              class="messagebox-icon iconinline icon x-24 transform45 marT18 send-icon"
                            ></a>
                          </div>
                          <span class="marT24">
                            <a href="javascript:void(0)" [hidden]="processStageDisable">
                              <img
                                src="assets/images/icons/default_icons/icon-services.png"
                                alt="icon-services"
                                id="serviceBtnId"
                                [matMenuTriggerFor]="activityMenu"
                                #trigger="matMenuTrigger"
                                width="20px"
                                height="20px"
                                (click)="setActivityState()"
                              />
                            </a>
                            <img
                              src="assets/images/icons/default_icons/icon-attachment.png"
                              alt="icon-attachment"
                              class="pointer"
                              width="20px"
                              height="20px"
                            />
                          </span>
                        </span>
                      </li>
                    </ul>
                  </span>
                </div>
                <mat-menu #activityMenu="matMenu" class="custom-menu" yPosition="above" xPosition="before" name="mmenu">
                  <!-- <ul class="listItemSingle" *ngFor="let item of activityList">
                                <li>
                                    <button mat-flat-button id="button" name="button" class="btn text-left btnclr btnblock GreyDarkest"
                                        (click)="displayService(item)">
                                        <strong>{{item.activityDescription}}</strong>
                                    </button>
                                </li>
                            </ul> -->
                  <!-- activity part starts-->
                  <app-activity-footer
                    [selectedCandidate]="selectedCandidate"
                    [processTypeList]="processActivityList"
                    [processStage]="processStage"
                    [autoTriggerActivity]="pendingAutoTrigger"
                    *ngIf="selectedCandidate"
                    (customPreScreeningEvent)="updatePreScreenProcess($event)"
                    (customScreeningEvent)="updateScreenProcess($event)"
                    (ROAEvent)="updateROA($event)"
                    (customInterviewEvent)="updateInterviewProcess($event)"
                    (suitabiltyCheckEvent)="updateSuitability($event)"
                    (correspondenceCheckEvent)="updateCorrespondence($event)"
                    (interviewCheckEvent)="updateInterviewSchedule($event)"
                    (statusEvent)="updateStatusChange($event)"
                    (hrPanelUpdateEvent)="updateHrPanelChange($event)"
                    (updateactivityselected)="clearActivityObj()"
                    (coupledSuitabiltyCheckEvent)="updateSuitabilityCoupled($event)"
                    (coupledInterviewCheckEvent)="updateInterviewScheduleCoupled($event)"
                    (coupledStatusEvent)="updateStatusChangeCoupled($event)"
                    (coupledCorrespondenceCheckEvent)="updateCorrespondenceCoupled($event)"
                    (coupledhrPanelUpdateEvent)="updateHrPanelChangeCoupled($event)"
                    (coupled2SuitabiltyCheckEvent)="updateSuitabilityCoupled2($event)"
                    (coupled2InterviewCheckEvent)="updateInterviewScheduleCoupled2($event)"
                    (coupled2StatusEvent)="updateStatusChangeCoupled2($event)"
                    (coupled2CorrespondenceCheckEvent)="updateCorrespondenceCoupled2($event)"
                    (coupled2hrPanelUpdateEvent)="updateHrPanelChangeCoupled2($event)"
                    (updateifcoupled)="updateifcoupled($event)"
                    (hrPanelUpdateEvent)="updateHrPanelChange($event)"
                  >
                  </app-activity-footer>

                  <!-- activity part ends -->
                </mat-menu>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
